import type { IAuthState } from '@/store/modules/auth/types';

export const state: IAuthState = {
  accessToken: '',
  isCompleted: false,
  isLogged: false,
  account: null,
  referrerURL: null,
};
